import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

import { LayoutService } from 'src/app/core/components/app-layout/services/layout.service';
import { Tenant, BaseLine, Simulaton } from 'src/app/core/models/baseLine-tree.model';
import { NotificationService } from 'src/app/core/services/notification.service';
import { StorageService } from 'src/app/core/services/storage.service';

@Component({
  selector: 'app-right-side-tree',
  templateUrl: './right-side-tree.component.html',
  styleUrls: ['./right-side-tree.component.scss']
})
export class RightSideTreeComponent implements OnInit {
  constructor(private router: Router,
    private layoutService: LayoutService,
    private session: StorageService,
    private notifier: NotificationService) { }
  tenantList: Tenant[] = [];

  selectedType: any;
  @ViewChild('id') el: ElementRef;
  dataUpdated = false;  
  ngOnInit(): void {
    this.layoutService.getbaseLineTree(this.session.userId)
      .subscribe((res) => {
        //console.log('this.tenantList',res);
        this.tenantList = res;
        this.tenantList.forEach(tenant=>{          
          tenant.baseLines.forEach(baseline=>{            
            baseline.simulatons.forEach(sim=>{
              if(this.session.selectedType.type==2 && sim.simulationId == this.session.selectedType.typeId){                
                baseline['active'] = true;
                tenant['active'] = true;
              }
            });
            if(this.session.selectedType.type==1 && baseline.baselineId == this.session.selectedType.typeId){                            
              baseline['active'] = true;
              tenant['active'] = true;
            }
          });          
        });
      });
  }

  toggleBaseline(isActive){    
    if(isActive){      
      return 'baseline-open';
    } else {
      return '';
    }
  }

  toggleTenant(isActive){    
    if(isActive){      
      return 'tenant-open';
    } else {
      return '';
    }
  }

  onSelect(eve, type: number, baseLine: BaseLine, tenant: Tenant, simulation?: Simulaton): void {
    const selectedType =
    {
      tenantId: tenant.tenantId,
      baselineSimulationType: type,
      typeId: (simulation == null) ? baseLine.baselineId : simulation?.simulationId,
      baselineId: baseLine.baselineId,
      simulationId: simulation?.simulationId,
      userId: this.session.userId
    };
    //console.log('type selected', JSON.stringify(selectedType));
    this.layoutService.saveAccountDetails(selectedType).subscribe(
      (val) => {
        this.dataUpdated = true;
        this.setAccountDetails();
      },
      response => {
        console.log('POST call in error', response);
        this.notifier.showError(this.session.resource?.tenantTree.cant);
      });
      
    this.el.nativeElement.style.display = 'none';
    eve.stopPropagation();
    sessionStorage.removeItem(btoa('selectedChannelId'));
    sessionStorage.removeItem(btoa('selectedRouteTypeId'));
  }


  setAccountDetails(): void {
    this.layoutService.getAccountDetails(this.session.userId)
    .subscribe((response) => {
     // console.log('account details got are: ', response);
      if (response === null) {
          this.notifier.showError(this.session.resource?.tenantTree.select);
          console.log('this.session.selectedType', this.session.selectedType);
        }
        else {
          let res = response;
          this.session.selectedType = {
            type: res.baselineSimulationType,
            typeId: res.typeId,
            tenantId: res.tenantId,
            userEmail: (this.session.userEmail)?this.session.userEmail: '',
            userName: (this.session.userEmail)?this.session.userEmail: '',
            userId: this.session.userId,
            simulationId: res.simulationId,
            simulationName: res.simulationName,
            simulationYear: res.simulationYear,
            baselineId: res.baselineId,
            baselineName: res.baselineName,
            baselineYear: res.baselineYear,
            isReadOnly: res.isReadOnly,
            currency: res.baselineCurrency,
            precision: res.baselinePrecision,
            isLocked:res.isLocked
          };
          window.location.reload();
          //this.router.navigate([this.router.url]);
        }
        if (this.dataUpdated) {
          this.layoutService.treeValueChange.next(!this.layoutService.isTreeUpdated);
          this.dataUpdated = false;
        }
      });
  }
}
